import { getExistingOptInAgreementIdentifiers } from './cookieHelper'
import { createComputedPropertyLessClone } from './jsonHelper'

export const buildProfile = (profileJson, optIns) => {
  const profile = createComputedPropertyLessClone(profileJson)
  profile.optInAgreementIdentifiers = getExistingOptInAgreementIdentifiers(profile, optIns)
  return profile
}
